module.exports = __webpack_public_path__ + "img/gsxw_2.6b3ca480.png";